import {
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers-pro';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DraggableDialog } from '~/components/Dialogs/components/DraggableDialog';
import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import {
  UseEditWorklistDialogProps,
  useEditWorklistDialog,
} from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistDialog/useEditWorklistDialog';
import { useSxStyles } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistDialog/useStyles';
import { convertDateTypeDatePickerProps } from '~/utils/helpers/date';

type PropsType = {
  open: boolean;
} & UseEditWorklistDialogProps;

export const EditWorklistDialog = (props: PropsType) => {
  const { open, ...dataProps } = props;

  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  const {
    form: { control },
    onCloseDialog,
    onSubmit,
    worklistTemplate,
    getTaskTypeName,
    dateLimits: { dueDateMin, startDateMax },
  } = useEditWorklistDialog(dataProps);

  return (
    <DraggableDialog open={open} onClose={onCloseDialog}>
      <SolaForceDialogTitle onClose={onCloseDialog}>
        {t('laEdit')}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <Box sx={sxStyles.root}>
          {!!worklistTemplate && (
            <List disablePadding={true}>
              <ListItem disablePadding={true}>
                <ListItemText
                  primary={
                    <>
                      {worklistTemplate.fCollaborationTemplateTitle}{' '}
                      <Chip
                        label={
                          getTaskTypeName(
                            worklistTemplate.fCollaborationTemplateTypeFK,
                          ) ?? ''
                        }
                        size="small"
                      />
                    </>
                  }
                  secondary={worklistTemplate.fCollaborationTemplateDescription}
                  sx={sxStyles.templateOption}
                />
              </ListItem>
            </List>
          )}
          <Controller
            control={control}
            name={'startDate'}
            render={({ field: { value, onChange }, fieldState: { error } }) => {
              return (
                <DatePicker
                  {...convertDateTypeDatePickerProps({
                    value,
                    onChange,
                    maxDate: startDateMax,
                  })}
                  label={t('startDate')}
                  slotProps={{
                    field: {
                      clearable: true,
                    },
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      error: !!error,
                      helperText: error?.message,
                    },
                  }}
                />
              );
            }}
          />
          <Controller
            control={control}
            name={'dueDate'}
            render={({ field: { value, onChange }, fieldState: { error } }) => {
              return (
                <DatePicker
                  {...convertDateTypeDatePickerProps({
                    value,
                    onChange,
                    minDate: dueDateMin,
                  })}
                  label={t('dueDate')}
                  slotProps={{
                    field: {
                      clearable: true,
                    },
                    textField: {
                      fullWidth: true,
                      size: 'small',
                      error: !!error,
                      helperText: error?.message,
                      required: true,
                    },
                  }}
                />
              );
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseDialog}>{t('cancel')}</Button>
        <Button onClick={onSubmit}>{t('save')}</Button>
      </DialogActions>
    </DraggableDialog>
  );
};
